import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import { Close } from '@mui/icons-material';

export const DialogCloseButton = ({
  onClose,
  sx,
  ...props
}: { onClose: () => void } & IconButtonProps) => {
  return (
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={{
        position: 'absolute',
        right: 16,
        top: 8,
        color: (theme) => theme.palette.grey[900],
        zIndex: 1,
        ...sx,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <Close />
    </IconButton>
  );
};
